export enum FlowId {
  HEADLESS = '05d0d96c-49bc-47a4-959f-535249b61ea9',
  NEW_HEADLESS = 'e440d7fa-ff2b-4a29-b49d-963ae0f8d69a',
  HEADLESS_MOBILE = 'cf689805-8c09-41da-a14c-db1ebd6cfbc7',
  STUDIO = '343d9759-28d3-4c2a-862b-d7a6d74831f4',
}
